import { IAppInitialContext, IAppInitialState } from "./AppProviderTypes"

export const APP_INITIAL_CONTEXT: IAppInitialContext = {
  setState: null,
  user: null,
  userRole: null,
  userName: "string",
  isAdmin: false,
  isAuthenticated: false,
  holidays: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  adminHolidays: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  branches: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  laundry: null,
  holidaysCurrentPage: 1,
  addLaundryHoliday: () => {},
  addAdminLaundryHoliday: () => {},
  updateLaundryHoliday: () => {},
  deleteLaundryHoliday: () => {},
  currentHoliday: null,
  laundryChangesCount: null,
  setCurrentHoliday: () => {},
  adminCurrentHoliday: () => {},
  setAdminCurrentHoliday: () => {},
  laundryBranchesDataLoading: false,
  updateReservationBoxLoading: false,
  updateReservationBox: () => {},
  selectedBranches: [],
  selectedBranchesForHolidays: [],
  branchesSearchValue: "",
  updateSelectedBranches: () => {},
  updateSelectedBranchesForHolidays: () => {},
  refetchLaundryBranches: () => {},
  updateBranchesSearchValue: () => {},
  reservationIdsToUpdate: [],
  boxAssignInfo: null,
  verifiedBoxAssignInfo: {
    data: [],
    status: 0,
    statusDescription: "",
  },
}

export const APP_INITIAL_STATE: IAppInitialState = {
  user: null,
  isAdmin: false,
  userRole: null,
  userName: "string",
  holidays: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  adminHolidays: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  laundry: null,
  holidaysCurrentPage: 1,
  selectedBranches: [],
  selectedBranchesForHolidays: [],
}
